<template>
  <div class="introduction">
    <div class="introduction-banner">
      <img src="@/assets/twoStar/hualu-jianj.png" alt />
    </div>
    <div class="introduction-content">
      <div class="introduction-content-title">华陆大厦综合党委简介</div>
      <p>
        华陆大厦建于2015年，毗邻市委市政府，配套建设欧陆风情商业街和2个现代小区，2020年企业产值逾2亿元，纳税4000余万元。该大厦综合党委成立于2020年，下辖党组织11个，现有党员66名、从业人员734人，辐射区域企业、商户110余家，覆盖服务小区居民5400余人。综合党委探索形成“三化”工作法，推动区域共建共治、融合发展。      </p>
      <p>
        <span class="second-title">治理多元化。</span>选派街道党工委副书记任书记，社区党委书记、企业党支部书记任副书记，商圈、物业、小区、青年人才党支部书记任委员，市级职能部门任兼职委员，构建职能部门、街道社区、物业公司、楼宇企业、附属小区、配套商圈共驻共建的“多元共治”党建体系。
      </p>
      <p>
        <span class="second-title">运行长效化。</span>以打造1个商企联盟为重点，制定党委班子每月走访1次挂钩企业收集发展需求、综合党委每3个月召开1次区域联席会议、每半年召开1次总结推进会议3项机制，常态开展温暖行动、青年联谊、义务劳动、主题党日、爱国教育、星级评定6类活动，建立“136”长效化运行模式。
      </p>
      <p>
        <span class="second-title">服务亲民化。</span>统筹政府、商企、居民资源，以辖区各方诉求为导向，精准开展党务、政务、商务、社区、志愿5项亲民化服务，实现资源联享、区域共治。2021年来，开展各项服务21次，惠及职工居民余4600余人次。
      </p>
      <img src="@/assets/twoStar/image1.jpg" alt="">
      <img src="@/assets/twoStar/image2.jpg" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.introduction {
  &-content {
    p {
      text-indent: 0.4rem;
      color: #333333;
      margin-bottom: 0.2rem;
    }
    &-title {
      font-weight: bold;
      font-size: 0.36rem;
      text-align: center;
      line-height: 3;
    }
    img {
      max-width: 100%;
    }
    position: absolute;
    top: 2.5rem;
    width: 94%;
    left: 3%;
    box-shadow: 0px 0.08rem 0.24rem 0px rgba(0, 0, 0, 0.17);
    border-radius: 0.08rem;
    padding: 0.2rem;
    padding-bottom: .5rem;
    .second-title {
      font-weight: bold;
    }
  }
  &-banner {
    img {
      width: 100%;
    }
  }
  padding: 1rem 0.2rem 0;
  font-size: 0.3rem;
  background: #fff;
}
</style>